const PIXEL_ID = '1652149349437497'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export function initPixel() {
  // Remove any existing fbq to prevent phantom pixels from the environment
  delete window.fbq
  delete window._fbq

  // Remove any existing Meta Pixel scripts
  document
    .querySelectorAll('script[src*="fbevents.js"]')
    .forEach((el) => el.remove())

  // Initialize fbq from scratch
  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(t)

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Rescate de Pareja: Post-Crisis',
      content_type: 'product',
      value: 8800,
      currency: 'ARS',
    })
  }
}
